export const ANON_ID_HEADER_NAME = 'X-Anon-Id';